import { createContext } from 'react';
import { Api } from '../data/api';

export const ApiContext = createContext<Api>(new Api());
